import { useCallback, useContext, useEffect, useRef, useState } from "react"
import { ApiContextDominios } from "../context/apiContextDominios.js"

export const NOTIF_REFRESH_EVENT = "lutente-notificaciones-refresh"
const POLL_MS = 20000
const LS_PERMISO = "lutenteNotifPermisoPedido"

export function pedirRefreshNotificaciones() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(NOTIF_REFRESH_EVENT))
  }
}

const pedirPermisoNativo = async () => {
  if (typeof window === "undefined" || typeof Notification === "undefined") return
  if (localStorage.getItem(LS_PERMISO)) return
  localStorage.setItem(LS_PERMISO, "1")
  if (Notification.permission !== "default") return
  try {
    await Notification.requestPermission()
  } catch {
    /* iOS / browsers sin permiso interactivo */
  }
}

const mostrarAvisoNativo = (count) => {
  if (typeof window === "undefined" || typeof Notification === "undefined") return
  if (Notification.permission !== "granted") return
  const n = Number(count) || 0
  const body = n <= 1 ? "Tenés pedidos para enviar" : `Tenés ${n} envíos sin ver`
  try {
    new Notification("Nuevo envío", { body, tag: "lutente-envio-nuevo" })
  } catch {
    /* ignore */
  }
}

/**
 * Poll de no leídas + aviso nativo del browser (solo con el ERP abierto).
 * `enabled` debe ser true si el usuario tiene VENTAS9.
 */
const useNotificacionesInbox = (enabled) => {
  const { getNotificacionesUnread } = useContext(ApiContextDominios)
  const [count, setCount] = useState(0)
  const countRef = useRef(0)
  const getUnreadRef = useRef(getNotificacionesUnread)
  getUnreadRef.current = getNotificacionesUnread

  const refresh = useCallback(async ({ anunciar = false } = {}) => {
    if (!enabled) {
      countRef.current = 0
      setCount(0)
      return 0
    }
    const resp = await getUnreadRef.current()
    const siguiente = Number(resp?.data?.tipos?.envio_nuevo ?? resp?.data?.count ?? 0) || 0
    const anterior = countRef.current
    countRef.current = siguiente
    setCount(siguiente)
    if (anunciar && siguiente > anterior) {
      mostrarAvisoNativo(siguiente)
    }
    return siguiente
  }, [enabled])

  useEffect(() => {
    if (!enabled) {
      countRef.current = 0
      setCount(0)
      return undefined
    }

    pedirPermisoNativo()
    refresh({ anunciar: false })

    const timer = setInterval(() => {
      refresh({ anunciar: true })
    }, POLL_MS)

    const onFocus = () => refresh({ anunciar: true })
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh({ anunciar: true })
    }
    const onRefresh = () => refresh({ anunciar: false })

    window.addEventListener("focus", onFocus)
    document.addEventListener("visibilitychange", onVisible)
    window.addEventListener(NOTIF_REFRESH_EVENT, onRefresh)

    return () => {
      clearInterval(timer)
      window.removeEventListener("focus", onFocus)
      document.removeEventListener("visibilitychange", onVisible)
      window.removeEventListener(NOTIF_REFRESH_EVENT, onRefresh)
    }
  }, [enabled, refresh])

  return { count, refresh }
}

export default useNotificacionesInbox
